var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "print_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#print_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.757 16.583c-.369 0-.684-.13-.947-.393a1.287 1.287 0 01-.393-.944v-1.658h-1.42c-.368 0-.684-.13-.946-.393a1.295 1.295 0 01-.394-.952V8.84c0-.438.153-.811.46-1.12.305-.31.68-.464 1.124-.464H15.76c.437 0 .81.155 1.12.464.309.309.463.682.463 1.12v3.403c0 .369-.13.684-.393.947a1.286 1.286 0 01-.944.393h-1.418v1.66c0 .369-.13.684-.393.947-.261.262-.579.393-.951.393H6.757zM3.997 12.5h1.42c.01-.36.145-.667.405-.923.259-.257.57-.385.935-.385h6.487c.364 0 .675.128.935.385.259.256.394.564.404.923h1.441a.25.25 0 00.184-.072.25.25 0 00.073-.185V9.138a.741.741 0 00-.25-.57.836.836 0 00-.584-.228H4.532a.762.762 0 00-.564.23.778.778 0 00-.227.57v3.103a.25.25 0 00.072.185.25.25 0 00.184.072zM13.5 7.256V5.013a.25.25 0 00-.072-.184.25.25 0 00-.184-.073H6.757a.25.25 0 00-.185.073.25.25 0 00-.072.184v2.243H5.417V5.013c0-.373.131-.69.393-.95.263-.26.578-.39.947-.39h6.487c.368 0 .684.131.946.394.262.262.393.577.393.946v2.243H13.5zm1.085 3.084c.212 0 .39-.072.536-.215a.714.714 0 00.219-.53.736.736 0 00-.214-.537.714.714 0 00-.532-.218.736.736 0 00-.535.214.714.714 0 00-.22.531c0 .212.072.39.215.536.143.146.32.219.531.219zM13.5 15.243v-2.711a.25.25 0 00-.072-.184.25.25 0 00-.184-.072H6.757a.25.25 0 00-.185.072.25.25 0 00-.072.184v2.711a.25.25 0 00.072.185.25.25 0 00.185.072h6.487a.25.25 0 00.184-.072.25.25 0 00.072-.185z",
    fill: "#7A8D8F"
  }))));
}
export default SvgPrint;